module.exports = __webpack_public_path__ + "static/pourquoi-irriglobe-0f0ee2dde78fdd141ea36c6f735b404b.webm";